var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Batch',{attrs:{"title":"项目奖申报批次"},on:{"handleNext":_vm.handleNext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }